import {
  WSCollapsible,
  WSElement,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { ICOIExtractionInterface } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { mapCOIPolicyToDataView } from "../../configs/helpers/mapCOIPolicyToDataView";

import { DataViewGrid } from "../../../../../../shared/components/DataView";

type PoliciesProps = {
  policies: NonNullable<ICOIExtractionInterface["policies"]>;
};

export const SharedFilePolicies: React.FC<PoliciesProps> = ({ policies }) => {
  if (!policies?.length) {
    return null;
  }

  return (
    <WSElement>
      <WSSectionToolbar title="Additional information" />
      <WSText.ParagraphSm color="gray500" mb="L">
        The PDF contains the following policies – they may not all apply to this
        validation check.
      </WSText.ParagraphSm>
      <WSList gap="XL">
        {policies.map((policy, index) => (
          <WSCollapsible
            key={index}
            icon="details"
            title={`Policy ${index + 1}: ${policy.policyType}`}
          >
            <DataViewGrid data={mapCOIPolicyToDataView(policy)} />
          </WSCollapsible>
        ))}
      </WSList>
    </WSElement>
  );
};
